<script lang="ts">
  import { haptic } from "../lib/tg";

  let {
    open = $bindable(false),
    prefill = "",
    onsubmit,
  }: {
    open?: boolean;
    prefill?: string;
    onsubmit?: (text: string) => void;
  } = $props();

  let input = $state("");
  let textarea: HTMLTextAreaElement | null = $state(null);
  let lastSeenPrefill = "";

  $effect(() => {
    if (open) {
      // Seed input from prefill on each open (only when prefill changed)
      if (prefill !== lastSeenPrefill) {
        input = prefill;
        lastSeenPrefill = prefill;
      }
      if (textarea) {
        setTimeout(() => {
          textarea?.focus();
          // place caret at end so user can continue editing
          const len = textarea?.value.length ?? 0;
          textarea?.setSelectionRange(len, len);
        }, 200);
      }
    }
  });

  function close() {
    open = false;
    input = "";
  }

  function submit() {
    const text = input.trim();
    if (!text) return;
    haptic("medium");
    onsubmit?.(text);
    close();
  }

  function handleKey(ev: KeyboardEvent) {
    // Ctrl+Enter / Cmd+Enter submit
    if ((ev.ctrlKey || ev.metaKey) && ev.key === "Enter") {
      ev.preventDefault();
      submit();
    }
  }
</script>

{#if open}
  <div class="backdrop" onclick={close} role="presentation"></div>
  <div class="sheet" role="dialog" aria-label="Команда текстом">
    <div class="grab"></div>
    <div class="title">Команда текстом</div>
    <div class="hint">Например: «поставь Ушаневу задачу позвонить Карине завтра в 14»</div>

    <textarea
      bind:this={textarea}
      bind:value={input}
      onkeydown={handleKey}
      placeholder="Что нужно сделать?"
      rows="3"
    ></textarea>

    <div class="actions">
      <button class="btn ghost" onclick={close}>Отмена</button>
      <button class="btn primary" onclick={submit} disabled={!input.trim()}>
        Разобрать
      </button>
    </div>
  </div>
{/if}

<style>
  .backdrop {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 60;
    animation: fade 160ms ease;
  }
  .sheet {
    position: fixed;
    left: 0; right: 0; bottom: 0;
    background: var(--bg-elev);
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
    padding: 12px 18px calc(18px + var(--safe-bottom, 0px));
    box-shadow: var(--shadow-lg);
    z-index: 70;
    animation: slide 220ms cubic-bezier(.18,.89,.32,1.05);
  }
  .grab {
    width: 36px; height: 4px;
    background: var(--border-strong);
    border-radius: 2px;
    margin: 0 auto 12px;
  }
  .title {
    font-family: 'Manrope', sans-serif;
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 4px;
    color: var(--text);
  }
  .hint {
    font-size: 11px;
    color: var(--text-dim);
    margin-bottom: 12px;
  }
  textarea {
    width: 100%;
    min-height: 80px;
    background: var(--bg-elev-2);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 12px;
    color: var(--text);
    font-family: inherit;
    font-size: 14px;
    line-height: 1.4;
    resize: none;
  }
  textarea:focus { border-color: var(--ember); outline: none; }

  .actions {
    display: grid;
    grid-template-columns: 1fr 1.6fr;
    gap: 8px;
    margin-top: 12px;
  }
  .btn {
    height: 46px;
    border-radius: 12px;
    font-family: 'Manrope', sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
  }
  .btn:active { filter: brightness(0.92); }
  .btn.ghost {
    background: var(--bg-elev-2);
    color: var(--text);
    border: 1px solid var(--border);
  }
  .btn.primary {
    background: var(--ember);
    color: #fff;
    border: none;
    box-shadow: var(--shadow-sm);
  }
  .btn.primary:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  @keyframes fade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slide { from { transform: translateY(100%); } to { transform: translateY(0); } }
</style>
